import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { RootState } from '../../../features';
import { throttle } from '../../../lib/utils';
import { FadeRoute } from '../../shared/routes/FadeRoute';
import { MyDesignDetail } from './MyDesignDetail';
import { MyDesignDetailMenu } from './MyDesignDetailMenu';

export const MyDesignDetailDialog: React.FC = () => {
  const routeMatch = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation('my_design');
  const { uploadedMyDesign } = useSelector((state: RootState) => state.myDesign);

  const handleMenuClick = useCallback(
    throttle(() => {
      if (routeMatch) {
        history.replace(`/players/my-design/detail/menu/1`);
      }
    }, 1000),
    [routeMatch, history]
  );

  const hasMenu = routeMatch?.url === location.pathname;

  return (
    <Dialog
      hasHeader={true}
      hasMenu={hasMenu}
      menuAriaLabel={t('aria_button_delete_design')}
      onMenuClick={handleMenuClick}
    >
      <div
        className={css`
          position: relative;
          min-height: 320px;
        `}
      >
        {uploadedMyDesign && <MyDesignDetail myDesign={uploadedMyDesign} hasMenu={hasMenu} />}

        <FadeRoute path="/players/my-design/detail/menu/:page">
          <MyDesignDetailMenu />
        </FadeRoute>
      </div>
    </Dialog>
  );
};
